  <template>
    <div class="h100vh-116">
      <div class='h-ainfoBg'>
        <div class='h-ainfo'>
          <span class='icon hero-icon hero-icon-detailcode'></span>
          <span>{{$t('MCS.choosed')}} {{ chooseCount }} {{$t('MCS.num')}}</span>
        </div>
      </div>
      <div style="height: calc(100vh - 200px) !important;">
        <ejs-grid ref='grid' :dataSource="data" height="calc(100% - 0px)" :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :actionComplete='getChooseCount' :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column type='checkbox' clipMode='EllipsisWithTooltip' headerText='mcsid' width='30' textAlign='Center'></e-column>
            <e-column field='userNum' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userNum")' width='150' textAlign='Center'></e-column>
            <e-column field='userAlias' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userAlias")' width='150' textAlign='Center'></e-column>
            <e-column field='participantType' clipMode='EllipsisWithTooltip' :valueAccessor='participantTypeFormatter' :headerText='$t("MCS.participantType")' width='150' textAlign='Center'></e-column>
            <e-column field='registerStatus' clipMode='EllipsisWithTooltip' :valueAccessor='registerStatusFormatter' :headerText='$t("MCS.registerStatus")' width='150' textAlign='Center'></e-column>
            <e-column field='stunStatus' clipMode='EllipsisWithTooltip' :valueAccessor='stunStatusFormatter' :headerText='$t("MCS.stunKillStatus")' width='150' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
      </div>
      <div style="display: none">
        <ejs-grid ref='gridExport' :dataSource="dataExport" :allowExcelExport='true' :actionComplete='excelExp'>
          <e-columns>
            <e-column field='userNum' :headerText='$t("MCS.userNum")' width='150' textAlign='Center'></e-column>
            <e-column field='userAlias' :headerText='$t("MCS.userAlias")' width='150' textAlign='Center'></e-column>
            <e-column field='participantType' :valueAccessor='participantTypeFormatter' :headerText='$t("MCS.participantType")' width='150' textAlign='Center'></e-column>
            <e-column field='registerStatus'  :valueAccessor='registerStatusFormatter' :headerText='$t("MCS.registerStatus")' width='150' textAlign='Center'></e-column>
            <e-column field='stunStatus' :valueAccessor='stunStatusFormatter' :headerText='$t("MCS.stunKillStatus")' width='150' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <CustomDialog ref='addUserPage' :element='dialog.element.eleAddUser' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <AddUserDialog ref='addUser' opCode='0' :neid='neid' :gmsNeid='gmsNeid' :equipmentIPId='equipmentIPId'></AddUserDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='modUserPage' :element='dialog.element.eleModUser' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <AddUserDialog ref='modUser' opCode='1' :neid='neid' :gmsNeid='gmsNeid' :equipmentIPId='equipmentIPId'></AddUserDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='groupListPage' :element='dialog.element.eleQryGroup' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <GroupList ref='groupList' :neid='neid'></GroupList>
        </template>
      </CustomDialog>
      <CustomDialog ref='addBlackListPage' :element='dialog.element.eleAddBlack' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <AddBlackDialog ref='addBlackList' :neid='neid'></AddBlackDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='qryBlackListPage' :element='dialog.element.eleModBlack' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <QryBlackDialog ref='qryBlackList' :neid='neid'></QryBlackDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='superSearchPage' :element='dialog.element.eleSearch' :styles='dialog.stylesSearch'>
        <template v-slot:dialog-content>
          <SuperSearch ref='superSearch' :userNumValue='userNumSearch' :userTypeValue='userTypeSearch' :reFreshGrid='reFreshGrid'></SuperSearch>
        </template>
      </CustomDialog>
      <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
        <template v-slot:dialog-content>
        <DialogList ref='dialog' ></DialogList>
        </template>
      </CustomDialog>
    </div>
  </template>
<script>
import { Edit, Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
import AddUserDialog from './dialog/AddUserDialog';
import CustomDialog from '../../../common/CustomDialog';
import GroupList from './dialog/QryGroupDialog';
import AddBlackDialog from './dialog/AddBlackDialog';
import QryBlackDialog from './dialog/QryBlackDialog';
import SuperSearch from './dialog/SearchDialog';
import DialogList from '../../util/tipDialog/DialogList';
import commonJS from '../common';

export default {
  name: 'CMSUsers',
  components: {
    CustomDialog,
    AddUserDialog,
    GroupList,
    AddBlackDialog,
    QryBlackDialog,
    SuperSearch,
    DialogList
  },
  mixins: [commonJS],
  data() {
    return {
      data: {},
      dataExport: {},
      requestAllData: [],
      dataExportPage: {
        pageNo: '',
        pageSize: 100
      },
      equipmentIPId: '',
      userNumSearch: '',
      userTypeSearch: 0,
      page: {
        pageNo: '1',
        pageSize: '100',
        totalCount: '0',
        pageCount: '0',
      },
      neid: '',
      gmsNeid: '',
      vo: {
        flag: '',
        participantType: ''
      },
      chooseCount: 0,
      dialog: {
        styles: {
          width: '810px',
          height: '760px',
          model: true,
          visible: false
        },
        stylesSearch: {
          width: '400px',
          height: '300px',
          visible: false,
          model: true
        },
        element: {
          eleAddUser: {
            target: this.$refs.userstable,
            refName: 'eleAddUser',
            buttonGroup: [
              { click: this.closeAddUserPage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveAddUser, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.addUser'),
            isClose: true
          },
          eleModUser: {
            target: this.$refs.userstable,
            refName: 'eleModUser',
            buttonGroup: [
              { click: this.closeModUserPage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveModUser, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.modUser'),
            isClose: true
          },
          eleQryGroup: {
            target: this.$refs.userstable,
            refName: 'eleQryGroup',
            buttonGroup: [
              { click: this.closeQryGroupList, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.qryGroupList'),
            isClose: true
          },
          eleAddBlack: {
            target: this.$refs.userstable,
            refName: 'eleAddBlack',
            buttonGroup: [
              { click: this.closeAddBlackList, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.addBlackNum'),
            isClose: true
          },
          eleModBlack: {
            target: this.$refs.userstable,
            refName: 'eleModBlack',
            buttonGroup: [
              { click: this.closeQryBlackList, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.manageBlackNum'),
            isClose: true
          },
          eleSearch: {
            target: this.$refs.userstable,
            refName: 'eleSearch',
            buttonGroup: [
              { click: this.closeSearch, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveSearch, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.qry'),
            isClose: true
          },
        },
      },
      dialogTip: {
        target: this.$refs.grouptable,
        refName: 'dialogList',
        buttonGroup: [
          {
            click: this.closeDialogListTipPage,
            buttonModel: { content: this.$t('MCS.cancle') }
          }
        ],
        title: this.$t('MCS.messageInfo'),
        isClose: true,
      },
    };
  },
  provide: {
    grid: [Edit, Reorder, Resize, ExcelExport, ContextMenu]
  },
  methods: {
    getGridData(ne = null) {
      const $this = this;
      let vo;
      if (ne !== null) {
        $this.neid = ne.data.id;
        $this.equipmentIPId = ne.data.equipmentIPId;
        vo = {
          flag: 0,
          participantType: 0
        };
        this.clearCondition();
      } else {
        vo = {
          flag: 2,
          userNum: this.userNumSearch,
          participantType: this.userTypeSearch
        };
      }
      const params = {
        info: this.setInfo(this.msg.qryUsers),
        vo: vo,
        page: {
          pageNo: $this.$refs.pager.ej2Instances.currentPage,
          pageSize: this.page.pageSize
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        if (response.data.errorCode === this.errorCode.breakLine) {
          $this.neid = '';
          $this.data = [];
          this.$toast('warning', this.$t('MCS.neOffLine'));
          return;
        }
        const res = response.data.resultVal;
        $this.data = res.result;
        $this.page.totalCount = res.countrsp;
      });
      this.$axios.post('/lte/ems/auth/findElementListByAuth', [14]).then((response) => {
        response.data.forEach((item) => {
          if (item.equipmentIPId === this.equipmentIPId) {
            $this.gmsNeid = item.id;
            return false;
          }
          return true;
        });
      });
    },

    isChooseNe() {
      if (this.neid === '') {
        this.$toast('warning', this.$t('MCS.chooseNe'));
        return false;
      }
      return true;
    },

    getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        this.$toast('warning', this.$t('Common.tips.noSelect'));
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        this.$toast('warning', this.$t('MCS.onlyData'));
        return false;
      }
      return selectedRecords;
    },

    getCheckedVals(selectOnly = false) {
      const mcsid = [];
      if (this.isChooseNe() !== false) {
        // x-> false: 不支持多选   true: 支持多选
        const checkedData = this.getCheckedData(selectOnly);
        for (let i = 0; i < checkedData.length; i++) {
          mcsid.push(checkedData[i].mcsid);
        }
      }
      return mcsid;
    },

    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },

    /**
     * 打开/关闭/保存  添加用户页面
     */
    openAddUserPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addUser.mainHandler();
      this.$refs.addUserPage.show();
    },
    closeAddUserPage() {
      this.$refs.addUserPage.clear();
      this.$refs.addUserPage.close();
    },
    saveAddUser() {
      const datas = this.$refs.addUser.getDatas();
      const userNumList = [];
      const userNum = this.$refs.addUser.getDatas().userNum;
      const opCount = this.$refs.addUser.getDatas().opCount;
      const resObj = [];
      for (let i = 0; i < opCount; i++) {
        const resData = {};
        resData.operObj = parseInt(userNum) + i;
        userNumList.push(resData.operObj)
        resObj.push(resData);
      }
      if (datas === false)  return;
      const params = {
        vo: datas,
        info: this.setInfo(this.msg.addUser),
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_user',
          execFunName: 'subscriber.addUser',
          exectype: 1,
          execData: userNumList
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        resObj.forEach((item, index) => {
          item.operResult = response.data.resultVal[index].display;
          item.operCode = response.data.resultVal[index].code;
        });
        this.$refs.dialog.addOperetionResultList(resObj);
        this.$refs.dialog.setTotalCount(opCount);
        this.$refs.dialogPage.show();
        this.getGridData();
      });
      // this.$layer.success();
      this.$refs.addUserPage.clear();
      this.$refs.addUserPage.close();
    },

    /**
     * 打开/关闭/保存  修改用户页面
     */
    openModUserPage() {
      const mcsid = this.getCheckedVals();
      if (mcsid.length !== 0) {
        const vo = {
          mcsid: mcsid[0],
          userNum: this.getCheckedData()[0].userNum,
          flag: 1
        };
        const page = {
          pageNo: 1,
          pageSize: 15
        };
        const params = {
          info: this.setInfo(this.msg.qryModUser),
          vo: vo,
          page: page
        };
        this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
          const data = response.data.resultVal.result[0];
          this.$refs.modUser.mainHandler(data);
          this.$refs.modUserPage.show();
        });
      }
    },
    closeModUserPage() {
      this.$refs.modUserPage.clear();
      this.$refs.modUserPage.close();
    },
    saveModUser() {
      const datas = this.$refs.modUser.getDatas();
      const params = {
        vo: datas,
        info: this.setInfo(this.msg.modUser),
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_user',
          execFunName: 'subscriber.modUser',
          exectype: 1,
          execData: [datas.userNum]
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        console.log('params', params);
        this.getGridData();
      });
      this.$toast('success');
      this.$refs.modUserPage.clear();
      this.$refs.modUserPage.close();
    },

    /**
     * 删除用户
     */
    delUsers() {
      const mcsid = this.getCheckedVals(true);
      const $this = this;
      if (mcsid.length > 0) {
        this.$layer.confirm({
          msg: this.$t('MCS.deleteConfirm'),
          btn1: {
            msg: this.$t('MCS.confirm'),
            func: () => {
              const usrNumFunc = () => {
                const userNum = [];
                $this.getCheckedData(true).forEach((item) => {
                  userNum.push(item.userNum);
                });
                return userNum;
              };
              const userNum = usrNumFunc();
              const resObj = [];
              const vo = {
                opCount: mcsid.length,
                mcsid: mcsid
              };
              for (let i = 0; i < vo.opCount; i++) {
                const resData = {};
                resData.operObj = userNum[i];
                resObj.push(resData);
              };
              const params = {
                vo: vo,
                info: this.setInfo(this.msg.delUser),
                log: {
                  module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_user',
                  execFunName: 'subscriber.delUser',
                  exectype: 1,
                  execData: userNum
                }
              };
              this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
                resObj.forEach((item, index) => {
                  item.operResult = response.data.resultVal[index].display;
                  item.operCode = response.data.resultVal[index].code;
                });
                this.$refs.dialog.addOperetionResultList(resObj);
                this.$refs.dialog.setTotalCount(vo.opCount);
                this.$refs.dialogPage.show();
                this.getGridData();
              });
            }
          },
          btn2: {
            msg: this.$t('MCS.cancle'),
          }
        });
      }
    },

    /**
     * 打开/关闭/保存  组呼列表页面
     */
    openQryGroupListPage() {
      const mcsid = this.getCheckedVals();
      if (mcsid.length !== 0) {
        // this.info.msgid = this.msg.qryGroupList;
        const vo = {
          flag: 1,
          page: 1,
          mcsid: mcsid[0],
          count: 200
        };
        const page = {
          pageNo: 1,
          pageSize: 100
        };
        this.$refs.groupList.getGroupList(page, vo, this.getCheckedData()[0].userNum, this.getCheckedData()[0].mcsid);
        this.$refs.groupListPage.show();
      }
    },
    closeQryGroupList() {
      this.$refs.groupListPage.clear();
      this.$refs.groupListPage.close();
    },

    /**
     * 打开/关闭/保存  添加黑名单页面
     */
    openAddBlackListPage() {
      const mcsid = this.getCheckedVals();
      if (mcsid.length !== 0) {
        this.$refs.addBlackList.getGridData(mcsid[0], this.getCheckedData()[0].userNum);
        this.$refs.addBlackListPage.show();
      }
    },
    closeAddBlackList() {
      this.$refs.addBlackListPage.clear();
      this.$refs.addBlackListPage.close();
    },

    /**
     * 打开/关闭/保存  黑名单管理页面
     */
    openQryBlackListPage() {
      const mcsid = this.getCheckedVals();
      if (mcsid.length !== 0) {
        this.$refs.qryBlackList.getGridData(mcsid, this.getCheckedData()[0].userNum);
        this.$refs.qryBlackListPage.show();
      }
    },
    closeQryBlackList() {
      this.$refs.qryBlackListPage.clear();
      this.$refs.qryBlackListPage.close();
    },

    /**
     * 导出
     */
    exportData() {
      if (this.isChooseNe() === false) {
        return;
      }
      const $this = this;
      const vo = {
        flag: 2,
        userNum: this.userNumSearch,
        participantType: this.userTypeSearch
      };
      const page = {
        pageNo: 1,
        pageSize: 100
      };
      $this.requestAllData = [];
      $this.circleRequest(vo, $this.setInfo(this.msg.qryUsers), page);
    },

    circleRequest(vo, info, page) {
      const $this = this;
      const params = {
        vo: vo,
        info: info,
        page: page
      }
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        const res = response.data;
        if (res.resultVal.result.length !== 0) {
          $this.requestAllData = $this.requestAllData.concat(res.resultVal.result);
        }
        if (res.resultVal.result.length === 100) {
          page.pageNo++;
          this.circleRequest(vo, info, page);
        } else {
          $this.dataExport = $this.requestAllData;
        }
      });
    },

    /**
     * 打开/关闭/保存  高级搜索
     */
    openSearchPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.superSearchPage.show();
      this.$refs.superSearch.bindValidate();
      return null;
    },
    closeSearch() {
      this.$refs.superSearchPage.clear();
      this.$refs.superSearchPage.close();
    },
    saveSearch() {
      if (!this.$refs.superSearch.checkValid()) {
        return;
      }
      this.$refs.superSearch.search();
      this.$refs.superSearchPage.clear();
      this.$refs.superSearchPage.close();
    },

    closeDialogListTipPage() {
      this.$refs.dialogPage.clear();
      this.$refs.dialogPage.close();
    },

    setInfo(msgid) {
      return {
        msgid: msgid,
        neid: this.neid,
      };
    },

    clearCondition() {
      this.userTypeSearch = 0;
      this.userNumSearch = '';
      this.$refs.superSearch.setData(0, '');
    },

    reFreshByNoCondition() {
      this.clearCondition();
      this.getGridData();
    },

    reFreshGrid(userType, userNum) {
      this.userTypeSearch = userType;
      this.userNumSearch = userNum;
      this.getGridData();
    },

    excelExp() {
      const dateStr = new Date().Format(`yyyy-MM-dd HH：mm`);
      const _excelName = `${this.$t('MCS.user')}_${dateStr}.xlsx`;
      this.$refs.gridExport.excelExport( { fileName: _excelName } );
    }

  },
  created() {
  }
};
</script>

<style scoped>

</style>
